import React from "react";
import createReactClass from "create-react-class";

import ModalAlbumCreate from "./modal_album_create";
import ModalAlert from "../modal/modal_alert";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      isAlbumCreatModalOpen: false,
      fadeClassName: "fade-in",
      scrollPos: 0,
    };
  },
  openModal() {
    var scrollPos = $("body").scrollTop();
    var marginLeft =
      (window.innerWidth - $("body .container").outerWidth()) / 2;
    $("body").css({
      position: "fixed",
      marginTop: -scrollPos,
      marginLeft: marginLeft,
    });
    this.setState({
      isAlbumCreatModalOpen: true,
      fadeClassName: "fade-in",
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $("body").css({ position: "relative", marginTop: "0", marginLeft: "0" });
    $("body").scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: "fade-out",
    });
    setTimeout(
      function() {
        this.setState({
          isAlbumCreatModalOpen: false,
        });
      }.bind(this),
      300
    );
  },
  handleSettingButton() {
    this.openModal();
  },
  // 「⋮」メニューの開け閉め（見た目のみ）。開くときに、写真の枚数と削除中かどうかを読んで項目の出し分けに使う
  openMenu() {
    var photoState = this.props.getPhotoState
      ? this.props.getPhotoState()
      : { count: 0, isDeleteMode: false };
    this.setState({ isMenuOpen: true, menuPhotoState: photoState });
  },
  closeMenu() {
    this.setState({ isMenuOpen: false });
  },
  handleMenuEdit() {
    this.closeMenu();
    this.handleSettingButton();
  },
  // 写真の削除は、これまでのゴミ箱ボタンと同じ処理（写真の並びの削除の切り替え）を呼ぶ
  handleMenuDeletePhotos() {
    this.closeMenu();
    if (this.props.changePhotoDeleteMode) {
      this.props.changePhotoDeleteMode();
    }
  },
  showAlbumCreateError() {
    this.modalAlertAlbumCreateError.openModal();
  },
  showNetworkError() {
    this.modalAlertNetworkError.openModal();
  },
  showPublicSettingError() {
    this.modalAlertPublicSettingError.openModal();
  },
  showStrageError() {
    this.modalAlertStrageError.openModal();
  },
  render() {
    return (
      <div>
        <ModalAlbumCreate
          isOpen={this.state.isAlbumCreatModalOpen}
          closeModal={this.closeModal}
          fadeClassName={this.state.fadeClassName}
          publicTypeData={this.props.publicTypeData}
          initialTitle={this.props.album.title}
          initialPublicType={this.props.album.public_type}
          initialDesctription={this.props.album.description}
          circleId={this.props.album.circle_id}
          albumId={this.props.album.id}
          isEditMode={true}
          photoStrageLimit={this.props.photoStrageLimit}
          chargePlanType={this.props.chargePlanType}
          isCirclePrivate={this.props.isCirclePrivate}
          showAlbumCreateError={this.showAlbumCreateError}
          showNetworkError={this.showNetworkError}
          showPublicSettingError={this.showPublicSettingError}
          showStrageError={this.showStrageError}
        />
        <div className="alb-head">
          {/* 見出しはアルバム一覧（画面63）と同じ作り: 上に小さくサークル名。
              サークル名は「⋮」の上の空きまで使えるよう、「⋮」と並ぶ行の外（上）に置く（デザイナー指示 2026-10-10） */}
          {this.props.circleName ? (
            <span className="alb-head__circle">{this.props.circleName}</span>
          ) : (
            ""
          )}
          <div className="alb-head__row">
            <h1 className="alb-head__title">
              {/* 公開範囲のタグは「サークル内限定」のときだけ（アルバム一覧のカードと同じ決まり）。
                  アルバム名の上・サークル名の下に置く（デザイナー判断 2026-10-08） */}
              {this.props.album.public_type != 4 ? (
                <span className="alb-head__tagline">
                  <span className="alb-tag">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
                    {this.props.publicTypeData[this.props.album.public_type].name}
                  </span>
                </span>
              ) : (
                ""
              )}
              {this.props.album.title}
            </h1>
            {this.props.myMemberType === 1 && this.props.photoCount === 0 ? (
              // 写真が0枚のときは、できる操作が編集だけなので「⋮」にせず「編集」ボタンをそのまま置く
              // （デザイナー判断 2026-10-10）。改修ずみ画面で共通の白いボタンの形
              <button
                type="button"
                className="alb-tool"
                onClick={this.handleSettingButton}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                編集
              </button>
            ) : this.props.myMemberType === 1 && this.props.photoCount > 0 ? (
              // 写真があるときは「編集」と「写真を削除」を「⋮」1つにまとめる（デザイナー判断 2026-10-10）。
              // 形はアルバム一覧（画面63）のカードの「⋮」メニューと同じ
              <div className="alb-card__side alb-head__menu">
                <button
                  type="button"
                  className="alb-card__kebab"
                  aria-label="アルバムのメニュー"
                  onClick={this.openMenu}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2" /><circle cx="12" cy="12" r="2" /><circle cx="12" cy="19" r="2" /></svg>
                </button>
                {this.state.isMenuOpen ? (
                  <React.Fragment>
                    <div className="alb-menu__backdrop" onClick={this.closeMenu} />
                    <div className="alb-menu" role="menu" aria-label="アルバムのメニュー">
                      <ul className="alb-menu__list">
                        <li>
                          <button type="button" className="alb-menu__item" onClick={this.handleMenuEdit}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" /></svg>
                            アルバムを編集
                          </button>
                        </li>
                        {/* 写真が無いときは消すものが無いので出さない */}
                        {this.state.menuPhotoState && this.state.menuPhotoState.count > 0 ? (
                          <li>
                            <button type="button" className="alb-menu__item alb-menu__item--danger" onClick={this.handleMenuDeletePhotos}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 6h18" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
                              {this.state.menuPhotoState.isDeleteMode ? "写真の削除を終える" : "写真を削除"}
                            </button>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          {this.props.album.description ? (
            <p className="alb-head__desc">{this.props.album.description}</p>
          ) : (
            ""
          )}
        </div>

        <ModalAlert
          ref={(c) => {
            this.modalAlertAlbumCreateError = c;
          }}
          title="エラー"
          content="アルバムの作成に失敗しました。後でもう一度試すか、運営にお問い合わせください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertNetworkError = c;
          }}
          title="エラー"
          content="ネットワークエラーが発生しました。後でもう一度試してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertPublicSettingError = c;
          }}
          title="公開範囲"
          content="サークルの公開設定が「非公開」なので、公開範囲を「サークルメンバー」でアルバムを保存することができません。サークルの公開設定を「公開」にするか、アルバムの公開範囲を「サークルメンバー」に設定してください。"
        />
        <ModalAlert
          ref={(c) => {
            this.modalAlertStrageError = c;
          }}
          title="容量制限"
          content="プライベートストレージの制限を超えているので、公開範囲を「サークルメンバー」でアルバムを保存することができません。アルバムの公開範囲を「公開」に設定するか、他の画像を削除してください。また、有料プランに加入するとプライベートストレージの制限を解除できます。"
        />
      </div>
    );
  },
});
